import styled from 'styled-components';

export const JiraAdminSettingsSectionLabels = styled.div`
  padding-top: 4px;
  margin-bottom: 24px;
`;

export const JiraAdminSettingsSectionLabelsSubtitle = styled.div`
  color: var(--ds-text-subtle, var(--ds-fb-text-subtle));
  margin-top: 8px;
`;

export const JiraAdminSettingsSectionTitle = styled.h2`
  padding-bottom: 24px;
`;

export const JiraAdminSettingsSectionToggle = styled.div`
  float: left;
  margin-right: 16px;
  margin-bottom: 40px;
`;
